'use client'
import { useState } from 'react'

import {
  SidebarContent,
  SidebarGroup,
  SidebarSeparator,
  useSidebar,
} from '@/components/ui/sidebar'

import { Checkbox } from '@/components/ui/checkbox'
import { Accordion } from '@/components/ui/accordion'

import { EducationalLevelAccordion } from './sections/educational-level'
import { RegionAccordion } from './sections/region'
import { MemberAccordion } from './sections/member'
// import { UniversityAccordion } from './sections/university'
import { RewardAccordion } from './sections/reward'
import { SortbySection } from './sections/sortby'
import { useContestPreferenceStore } from '@/stores/contest-preference-store'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { preferenceFormSchema } from '../preference/form'
import { cn } from '@/services/utils/cn'
import { Button } from '@/components/ui/button'
// import { InternationalAccordion } from './sections/international'

export function AppSidebarContent() {
  const store = useContestPreferenceStore()
  const { control, setValue, handleSubmit, formState } = useForm({
    resolver: zodResolver(preferenceFormSchema),
    defaultValues: {
      categories: store.categories,
      certificate: store.certificate,
      companyPartnership: store.companyPartnership,
      educationalLevels: store.educationalLevels,
      internship: store.internship,
      memberTypes: store.memberTypes,
      trophy: store.trophy,
      openDate: store.openDate ?? undefined,
      closingDate: store.closingDate ?? undefined,
      prizeNumberMax: store.prizeNumberMax ?? undefined,
      prizeNumberMin: store.prizeNumberMin ?? undefined,
      publishWork: store.publishWork,
      regions: store.regions,
      isViewActiveContests: store.isViewActiveContests,
      sortBy: store.sortBy,
      sortOrder: store.sortOrder,
      teamNumberMax: store.teamNumberMax ?? undefined,
      teamNumberMin: store.teamNumberMin ?? undefined,
    },
  })

  const [isPrizeSliderActive, setIsPrizeSliderActiveState] = useState(false)
  const [isBooleanOptionActive, setIsBooleanOptionActive] = useState(false)

  const { toggleSidebar } = useSidebar()

  async function handleSavePreference() {
    //
    toggleSidebar()
  }

  return (
    <>
      <SidebarSeparator className="mx-0 h-[0.5px] bg-black" />
      <SidebarContent>
        <SidebarGroup>
          <form
            onSubmit={handleSubmit(handleSavePreference)}
            className="grid py-6"
          >
            <Accordion type="multiple">
              <EducationalLevelAccordion control={control} />
              <RegionAccordion control={control} />
              <MemberAccordion control={control} />
              {/* <UniversityAccordion/> */}
              <RewardAccordion
                control={control}
                setValue={setValue}
                isPrizeSliderActive={isPrizeSliderActive}
                setIsPrizeSliderActive={setIsPrizeSliderActiveState}
                isBooleanOptionActive={isBooleanOptionActive}
                setIsBooleanOptionActive={setIsBooleanOptionActive}
              />
              {/* <InternationalAccordion /> */}
            </Accordion>
            <SortbySection control={control} setValue={setValue} />
            <div className="items-top mt-[31px] flex space-x-2 px-3">
              <Checkbox id="terms1" />
              <div className="grid gap-1.5 leading-none">
                <label
                  htmlFor="terms1"
                  className="text-sm font-bold leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                >
                  จดจำ preference ทุกครั้ง
                </label>
                <p className="text-sm text-muted-foreground">
                  หากไม่เลือกการตั้งค่านี้ ระบบจะ Reset การกรองไปสู่ปกติ
                </p>
              </div>
            </div>
            <div className="mt-[25px]">
              <Button
                variant="outline"
                className={cn(
                  'w-full rounded-full bg-transparent text-sm font-bold text-zinc-950',
                  formState.isDirty &&
                    'bg-zinc-950 text-white hover:bg-zinc-800 hover:text-white',
                  formState.isSubmitting && 'opacity-50'
                )}
              >
                Apply Filter
              </Button>
            </div>
          </form>
        </SidebarGroup>
      </SidebarContent>
    </>
  )
}
